export const handleAsyncState = async (
  callback: () => Promise<void>,
  setLoading: (loading: boolean) => void,
  setError: (error: Error | null) => void
) => {
  setLoading(true);
  setError(null);

  try {
    await callback();
  } catch (error) {
    setError(error as Error);
  } finally {
    setLoading(false);
  }
};
